import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import Text from '../Text/Text';
import { elo as theme } from '../../themes';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Header = function Header(_ref) {
  var header = _ref.header,
    isFirst = _ref.isFirst,
    isLast = _ref.isLast,
    dataTestId = _ref.dataTestId;
  return ___EmotionJSX("th", {
    onClick: header.onClick,
    style: {
      maxWidth: header.width,
      minWidth: header.width,
      cursor: header.onClick ? 'pointer' : 'initial',
      padding: 0,
      marginRight: !isLast && theme.spacings.xSmall,
      marginLeft: isFirst && theme.spacings.xxSmall
    },
    "data-test-id": "table-header-cell-" + dataTestId + "-" + header.id
  }, ___EmotionJSX(Text, {
    size: "t5",
    textTransform: "uppercase",
    dimmed: true,
    dataTestId: "table-header-text-" + dataTestId + "-" + header.id
  }, header.value), header.onClick && ___EmotionJSX(Icon, {
    type: "arrow-tip-sort",
    dataTestId: "table-header-icon-" + dataTestId + "-" + header.id,
    dimmed: true
  }));
};
Header.propTypes = {
  header: PropTypes.shape({
    id: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    width: PropTypes.number
  }).isRequired,
  isFirst: PropTypes.bool.isRequired,
  isLast: PropTypes.bool.isRequired,
  dataTestId: PropTypes.string
};
export default Header;